import { AccountConfigData, AccountConfigOptions } from "~/modules/config";
import { ErrorSeverity, ErrorCode } from "~/modules/error";
import { ClientOptions } from "~/modules/client";
import { ConfigurationService } from "~/backend/generated/Configuration/api/configuration.serviceInterface";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import { ConfigurationServiceImpl } from "~/backend/generated/Configuration/api/configuration.service";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";

const metadata = {
    module: "config",
    eventSource: "AccountConfigProvider.ts"
};




export type AccountConfigProvider = (
    sessionToken: string,
    options?: AccountConfigOptions
) => Promise<AccountConfigData>;




export const accountConfigProvider =
    (ctx: ContextManager) =>
    async (sessionToken: string, options: AccountConfigOptions = {}): Promise<AccountConfigData> => {
        const configurationService: ConfigurationService = ctx.retrieveInstanceOf(
            ContextInstance.ConfigurationServiceImpl,
            ConfigurationServiceImpl
        );
        const throwAndReportError = throwFlexSdkError(ctx);
        const clientOptions: ClientOptions = ctx.retrieveInstanceOf(
            ContextInstance.ClientOptionsStore,
            ClientOptionsStore
        );
        const uiVersion = clientOptions?.accountConfig.query?.UiVersion || options?.query?.UiVersion;
        try {
            const config = await configurationService.fetchConfiguration("UiVersion", uiVersion, {
                token: sessionToken
            });
            return config;
        } catch (err) {
            const message = `Failed to fetch account configuration: ${err}. `;
            const errorCode = err.code || ErrorCode.Unknown;
            return throwAndReportError(errorCode, { ...metadata, severity: ErrorSeverity.Error }, message);
        }
    };
